import React, { useEffect, useState } from 'react'
import { fetchJobDetails, updateDeliveryStatus } from '../../services/auth.service';
import { useDispatch, useSelector } from 'react-redux';
import { jobId, setLoader } from '../../slice/commonSlice';
import Header from '../../components/header/Header';
import PageHeading from '../../components/pageHeading/PageHeading';
import Footer from '../../components/footer/Footer';
import { toast } from "react-toastify";
import moment from 'moment';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { toast_error, toast_success, toast_warning } from '../../config/Constant';
import { getCurrentISODateTime } from '../../utils/common';
import ConfirmModal from '../../modals/confirmModal/ConfirmModal';
import StartSelfieModal from '../../modals/startSelfie/StartSelfieModal';


const JobDeliveryStatus = () => {
  const dispatch = useDispatch();
  const [details, setDetails] = useState({});
  const [jobDetails, setJobDetails] = useState({});
  const [selectedStatus, setSelectedStatus] = useState('');
  const [confirmStatus, setConfirmStatus] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [startSelfieModal, setStartSelfieModal] = useState(false);

  let id = useSelector(jobId);

  useEffect(() => {
    if (id) {
      fetchJob()
    }
  }, [id])

  const handleStatusChange = (e) => {
    setSelectedStatus(e);

    if(e === 'otw' && !jobDetails?.startSelfie) {
      setStartSelfieModal(true)
      return
    }
    // if(e === 'otw') {
    //   setStartSelfieModal(true)
    //   return
    // }
    
    setConfirmStatus(true);
    if(e === 'otw'){
      setConfirmText('You want to change status to On the way');
    } else if(e === 'inTransit'){
      setConfirmText('You want to change status to In Transit');
    } else if(e === 'delivered'){
      setConfirmText('You want to change status to Delivered')
    } else {
      setConfirmText('')
    }
  };

  const handleSubmit = async (e) => {
    updateStatus()
    // if (selectedStatus === 'otw') {
    //   if (jobDetails?.startSelfie) {
    //     updateStatus()
    //   } else {
    //     toast.warning('Upload your start selfie first', toast_warning)
    //   }
    // } else {
    //   updateStatus()
    // }
  };

  const updateStatus = async () => {
    let payload = {
      "jobId": id,
      [selectedStatus]: getCurrentISODateTime()
    }
  
    await dispatch(setLoader(true));
    try {
      const response = await updateDeliveryStatus(payload);
      toast.success(response?.data?.message, toast_success);
      await dispatch(setLoader(false));
      fetchJob();
    } catch (error) {
      await dispatch(setLoader(false));
      toast.error(error?.data?.message, toast_error)
      console.error("Error fetching data:", error);
    }
  }

  const fetchJob = async () => {
    let payload = {
      "id": id
    }
    await dispatch(setLoader(true));
    try {
      const response = await fetchJobDetails(payload);
      await dispatch(setLoader(false));
      let [job] = response.data?.jobData;
      setDetails(response.data);
      setJobDetails(job);
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  }

  const formatDateTime = (date) => {
    if (date) {
      const inputDate = moment.utc(date).tz('Atlantic/Bermuda');
      const formattedDate = inputDate.format('h:mm A, DD MMMM YYYY');
      return formattedDate;
    } else {
      return '';
    }
  };

  const checkDisabled = (opt, status) => {
    if (opt === 'otw' && (status === 'otw' || status === 'inTransit' || status === 'delivered')) {
      return true
    } else if (opt === 'inTransit' && (status === '' || status === 'inTransit' || status === 'delivered')) {
      return true
    } else if (opt === 'delivered' && (status === '' || status === 'otw' || status === 'delivered')) {
      return true
    }
  }

  const changeStatus = (status) =>{
    if (status === '') {
      return <Button onClick={()=>handleStatusChange('otw')} variant="primary">On the way</Button>
    } else if (status === 'otw') {
      return <Button onClick={()=>handleStatusChange('inTransit')} variant="primary">In Transit</Button>
    } else if (status === 'inTransit') {
      return <Button onClick={()=>handleStatusChange('delivered')} variant="primary">Delivered</Button>
    } else {
      return null
    }
  }

  const handleConfirm = (status) =>{
    if(status){
      handleSubmit();
    }
    setConfirmStatus(false);
  }

  const handleStartSelfieClose = () => {
    setStartSelfieModal(false)
    fetchJob();
  }

  return (
    <>
      <Header />
      <PageHeading title="Delivery Status" />
      <div className='main-container'>
        <div className='delivery-status-wrapper'>
          <div className='track-order-wrapper'>
            <div className='track-order-header'>
              <div className='track-title'>Track Order</div>
              <div className='track-id-number'>Order Id #{jobDetails?.jobId}</div>
            </div>
            <div className='track-step-wrapper'>
              <div className={`${!details?.latestTrackingData?.otw ? 'fade track-step-wrap' : 'track-step-wrap'}`} >
                <div className='track-step'>
                  <div className='track-step-number'><span>1</span></div>
                  <div className='track-line'></div>
                </div>
                <div className='track-step-message'>
                  <div className='track-step-title'>On The Way</div>
                  <div className='track-time-detail'>{formatDateTime(details?.latestTrackingData?.otw)}</div>
                </div>
              </div>
              <div className={`${!details?.latestTrackingData?.inTransit ? 'fade track-step-wrap' : 'track-step-wrap'}`}>
                <div className='track-step'>
                  <div className='track-step-number'><span>2</span></div>
                  <div className='track-line'></div>
                </div>
                <div className='track-step-message'>
                  <div className='track-step-title'>Transit</div>
                  <div className='track-time-detail'>{formatDateTime(details?.latestTrackingData?.inTransit)}</div>
                </div>
              </div>
              <div className={`${!details?.latestTrackingData?.delivered ? 'fade track-step-wrap' : 'track-step-wrap'}`}>
                <div className='track-step'>
                  <div className='track-step-number'><span>3</span></div>
                </div>
                <div className='track-step-message'>
                  <div className='track-step-title'>Delivered</div>
                  <div className='track-time-detail'>{formatDateTime(details?.latestTrackingData?.delivered)}</div>
                </div>
              </div>
            </div>
          </div>



          {
            details?.latestTrackingStatus !== 'delivered' ?
              <div className='d-flex gap-3 align-items-center'>
                {/* <Form>
              <Form.Group controlId="statusSelect">
                <Form.Label>Delivery Status</Form.Label>
                <Form.Control as="select" value={selectedStatus} onChange={handleStatusChange}>
                  <option value="">Select Status</option>
                  <option value="otw" disabled={checkDisabled('otw', details?.latestTrackingStatus)}>On the way</option>
                  <option value="inTransit" disabled={checkDisabled('inTransit', details?.latestTrackingStatus)}>Transit</option>
                  <option value="delivered" disabled={checkDisabled('delivered', details?.latestTrackingStatus)}>Delivered</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className='mt-4'>
                <div className="d-grid">
                  <Button type="submit" disabled={!selectedStatus} variant="primary" size="lg" onClick={handleSubmit}>
                    Update Status
                  </Button>
                </div>
              </Form.Group>
            </Form> */}
                <div>Change current status to: </div>
                {changeStatus(details?.latestTrackingStatus)}
                {/* <Button disabled={checkDisabled('otw', details?.latestTrackingStatus)} variant="primary">On the way</Button>
            <Button disabled={checkDisabled('inTransit', details?.latestTrackingStatus)} variant="primary">Transit</Button>
            <Button disabled={checkDisabled('delivered', details?.latestTrackingStatus)} variant="primary">Delivered</Button> */}
              </div>
            : null
          }
        </div>
      </div>
      {/* <div className='main-container'>
        {
          details ?
            <div className='container-wrap'>
              <h1>Track Order</h1>
              <p>Order Id #{jobDetails?.jobId}</p>
              <p>{details?.serviceId?.name}</p>
              <ol>
                <li className={`${details?.latestTrackingData?.otw ? 'active' : ''}`}>On the way: {formatDateTime(details?.latestTrackingData?.otw)}</li>
                <li className={`${details?.latestTrackingData?.inTransit ? 'active' : ''}`}>Transit: {formatDateTime(details?.latestTrackingData?.inTransit)}</li>
                <li className={`${details?.latestTrackingData?.delivered ? 'active' : ''}`}>Delivered: {formatDateTime(details?.latestTrackingData?.delivered)}</li>
              </ol>

              {
                details?.latestTrackingStatus !== 'delivered' ?
                <Form>
                <Form.Group controlId="statusSelect">
                  <Form.Label>Delivery Status</Form.Label>
                  <Form.Control as="select" value={selectedStatus} onChange={handleStatusChange}>
                    <option value="">Select Status</option>
                    <option value="otw" disabled={checkDisabled('otw', details?.latestTrackingStatus)}>On the way</option>
                    <option value="inTransit" disabled={checkDisabled('inTransit', details?.latestTrackingStatus)}>Transit</option>
                    <option value="delivered" disabled={checkDisabled('delivered', details?.latestTrackingStatus)}>Delivered</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group className='mb-4'>
                  <div className="d-grid">
                    <Button type="submit" disabled={!selectedStatus} variant="primary" size="lg" onClick={handleSubmit}>
                      Update Status
                    </Button>
                  </div>
                </Form.Group>
              </Form> : null
              }
              
            </div>
            :
            null
        }
      </div> */}
      <Footer />
      { confirmStatus ? <ConfirmModal isConfirm={confirmStatus} text={confirmText} handleClose={handleConfirm} /> : null }
      { startSelfieModal ? <StartSelfieModal startSelfieModal={startSelfieModal} handleStartSelfieClose={handleStartSelfieClose} details={details?.jobData[0]}/>  : null}
    </>
  )
}

export default JobDeliveryStatus